<template>
  <div class="multiple-select">
    <el-select
      class="first"
      :model-value="modelValue[0]"
      :placeholder="$t('commonTipSelect')"
      @update:modelValue="onChange"
      :clearable="clearable"
    >
      <el-option
        v-for="(item, index) in list"
        :key="`${item[valueKey]}-${index}`"
        :value="item[valueKey]"
        :label="item[labelKey]"
      ></el-option>
    </el-select>
    <el-select
      class="second"
      :model-value="modelValue[1]"
      :placeholder="$t('commonTipSelect')"
      @change="onChildChange"
      :clearable="clearable"
      ><el-option
        v-for="(item, index) in children"
        :key="`${item[valueKey]}-${index}`"
        :value="item[valueKey]"
        :label="item[labelKey]"
        :disabled="item.disabled"
      ></el-option
    ></el-select>
  </div>
</template>
<script>
import { computed, onMounted, reactive, toRefs, watch } from "vue";
export default {
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    labelKey: {
      type: String,
      default: "name",
    },
    valueKey: {
      type: String,
      default: "id",
    },
    childrenKey: {
      type: String,
      default: "children",
    },
  },
  setup(props, context) {
    const state = reactive({
      loading: false,
      // children: [],
      map: {},
    });

    const children = computed(() => {
      if (
        props.modelValue[0] === null ||
        props.modelValue[0] === undefined ||
        props.modelValue[0] === ""
      ) {
        return [];
      }
      if (!state.map[props.modelValue[0]]) {
        return [];
      }
      return state.map[props.modelValue[0]];
    });

    watch(
      () => props.list,
      () => {
        props.list.forEach((item) => {
          state.map[item[props.valueKey]] = item[props.childrenKey];
        });
      }
    );

    onMounted(() => {
      props.list.forEach((item) => {
        state.map[item[props.valueKey]] = item[props.childrenKey];
      });
    });

    const onChange = (value) => {
      context.emit("update:modelValue", [value, ""]);
    };
    const onChildChange = (value) => {
      context.emit("update:modelValue", [props.modelValue[0], value]);
    };
    return {
      ...toRefs(state),
      children,
      onChange,
      onChildChange,
    };
  },
};
</script>
<style lang="scss" scoped>
.multiple-select {
  display: flex;
  .first {
    margin-right: 5px;
  }
}
</style>
